<template>
    <MainPage :pageTitle="pageTitle" bgClass="bg-white">
        <div class="flex-none">
            <div class="img-place rounded-t-10">
                <img :src="imgPlace" class="rounded-t-10 w-full h-full object-cover" @error="onLoadImgError" alt=""/>
            </div>
        </div>
        <div class="place-detail">
            <div class="py-4 px-26px flex flex-col gap-3">
                <div class="title">
                    {{ detail.name }}
                </div>
                <div class="address">
                    {{ detail.address }}
                </div>
                <div class="info">
                    <PlaceCategoryInfo :item="detail" :coordinate="currentUserLocation" />
                </div>
            </div>
            <div class="py-4 px-26px flex flex-col gap-3.5">
                <div class="contact-numbers">
                    <ContactNumberList :detail="detail" />
                </div>
                <div class="">
                    <WorkingTime :detail="detail" />
                </div>
            </div>
        </div>

        <div class="bottom-nav">
            <MainButton class="h-12" @click="gMapButton.onClick(detail.location.latitude, detail.location.longitude)">
                <div class="leading-6">เส้นทาง</div>
            </MainButton>
        </div>
    </MainPage>
</template>

<script>
import { computed, defineComponent, provide, ref } from 'vue';
import PlaceModel from '../model/PlaceModel';
import useGoogleMapButton from '@/helper/composable/useGoogleMapButton';
// assets
import ImgDefault from "@/assets/img_default.jpg"
// component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import MainButton from '@/components/Button/MainButton.vue';
import PlaceCategoryInfo from '../component/PlaceCategoryInfo.vue';
import WorkingTime from '../component/WorkingTime.vue';
import ContactNumberList from '../component/ContactNumberList.vue';
import { onBeforeRouteLeave } from 'vue-router';
import ConfigManager from '@/config/ConfigManager';
import MapsService from '@/module/Maps/service/MapsService';

export default defineComponent({
    components: {
        MainPage,
        MainButton,
        PlaceCategoryInfo,
        WorkingTime,
        ContactNumberList
    },
    setup: function () {
        const pageTitle = computed(() => {
            return "ค้นหาอู่ , ศูนย์ซ่อม , โรงพยาบาลในเครือ"
        })
        const gMapButton = useGoogleMapButton()
        const cacheDetail = new PlaceModel()
        cacheDetail.loadCache()

        const detail = ref(cacheDetail)
        const imgPlace = ref(cacheDetail.image_url)

        const onLoadImgError = function () {
            imgPlace.value = ImgDefault
        }

        //#region google map
        const currentUserLocation = ref(null)
        const elemMap = ref(null);
        let googleKey = ConfigManager.getGoogleMapsKey();
        const mapService = MapsService(elemMap, {
            apiKey: googleKey,
            version: "weekly",
            libraries: ["places"]
        });
        mapService.getCurrentLocation().then((latLng) => {
            currentUserLocation.value = latLng
        })
        mapService.initMaps()

        provide("currentUserLocation", currentUserLocation)
        provide("mapService", mapService)
        //#endregion

        onBeforeRouteLeave(()=>{
            cacheDetail.clearCache()
        })

        return {
            detail,
            pageTitle,
            imgPlace,
            gMapButton,
            currentUserLocation,
            onLoadImgError
        }
    },
})
</script>

<style lang="scss" scoped>
.img-place {
    overflow: hidden;
    height: 210px;
    @apply w-full;
}

.place-detail {
    padding-bottom: 90px;
    @apply flex flex-col min-w-0 divide-y divide-a-gray-d0d0ce;

    .title {
        @apply font-medium text-base text-a-black-484848;
    }

    .address {
        font-size: 11px;
        @apply font-light text-a-black-484848;
    }

    .info {
        @apply flex items-center gap-2;
    }
}

.bottom-nav {
    @apply fixed left-0 right-0 bottom-0 w-full max-w-lg mx-auto flex flex-col items-center justify-center p-6 px-26;
}
</style>
